export default {
      id: "oc-excel-usage",
      viewBox: "0 0 1024 1024",
      url: __webpack_public_path__ + "sprite.svg#oc-excel",
      toString: function () {
        return this.url;
      }
    }